import { Box, Circle, Flex, VisuallyHidden } from '@chakra-ui/react';
import * as React from 'react';

import { CheckIcon } from '@/imports/ui/chakra/feather';

export const OnboardingChecklistItem: React.FC<{
  isChecked?: boolean;
  onClick?: () => void;
}> = (props) => {
  const { isChecked = false, children, onClick } = props;

  return (
    <Box>
      <Flex
        cursor={isChecked ? 'default' : 'pointer'}
        _hover={{ bg: isChecked ? undefined : 'gray.50' }}
        px="2"
        py="4"
        borderRadius="md"
        alignItems="center"
        onClick={isChecked ? undefined : onClick}
      >
        <Circle
          mr="4"
          size={6}
          bg={isChecked ? 'green.300' : 'white'}
          border="1px"
          borderColor={isChecked ? 'green.300' : 'gray.300'}
        >
          {isChecked && <CheckIcon color="white" boxSize={4} />}
        </Circle>
        <Box>
          {children}
          {isChecked && <VisuallyHidden>(Completed)</VisuallyHidden>}
        </Box>
      </Flex>
    </Box>
  );
};
